<template>
    <div>
        <breadcrumbs
            :title="'Pošte'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Pošte</h5>
                <br>
                <button
                    type="button"
                    class="btn btn-lg btn-primary"
                    @click.prevent="create"
                >
                    Nova pošta
                </button>
            </div>

        </div>
        <div class="ibox-content">
            <datatables
                v-if="show_datatable"
                :url="datatables_url"
                :settings="datatables.settings"
                :title="datatables.title"
                @rowClick="rowClick"
            ></datatables>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import Datatables from "../../../../components/datatable/Datatables";
export default {
    name: "Poste",
    components: { Datatables, Breadcrumbs },
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL + 'posta',
            datatables: {},
            breadcrumbs: []
        }
    },
    methods: {
        rowClick( row ){
            this.$router.push( { path: '/postavke/poste/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/postavke/poste/create' } )
        },

        setDatatable(){
            let vm = this

            vm.datatables = {
                settings: {
                    table_header: [
                        {
                            'id': 'id',
                            'visible': false
                        },
                        {
                            'id': 'mjesto',
                            'title': 'Mjesto',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'mjesto',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'postanski_broj',
                            'title': 'Poštanski broj',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'postanski_broj',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'zupanija_naziv',
                            'title': 'Županija',
                            'type': function( row ){
                                return row.zupanija ? row.zupanija.naziv : '';
                            },
                            'column_visibility_group': {
                                id: 'zupanije',
                                visible: true
                            }
                        },
                    ],
                    column_visibility_groups:{
                        'poste' : 'Pošte'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Pošte'
            }

            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/poste',
                    name: 'Pošte'
                }
            ]
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }

};
</script>

<style scoped>

</style>
